import React from "react";
import { useSelector } from "react-redux";
import { formatDate } from "../utils/utilities";
import defaultProfile from "../assets/Male 1.svg";
import { clockSvg, editSvg } from "../assets/svg";

function BookingSummarySection({ setActiveSection }) {
    const { selectedDoctor, selectedSpecialization, selectedAppointment } =
        useSelector((state) => state.appointment) || {};

    const isMobile = window.innerWidth <= 768;

    return (
        <div className="booking-summary-container">
            <div className="booking-summary-leftbar"></div>
            <div className="w-100 d-flex flex-column justify-content-center align-items-start pt-3 px-3 px-lg-5 pt-lg-0">
                <div className="f600-20px">Booking Summary</div>
                <div className="d-flex align-items-center justify-content-between w-100">
                    <div
                        className={
                            isMobile
                                ? "d-flex justify-content-between w-100"
                                : "d-flex justify-content-between align-items-center f600-18px w-100"
                        }
                    >
                        <div
                            className={
                                isMobile
                                    ? "w-100"
                                    : "d-flex align-items-center justify-content-between w-100"
                            }
                        >
                            <div className="d-flex align-items-center justify-content-start col">
                                <div className={isMobile ? "pe-3" : ""}>
                                    <img
                                        src={
                                            selectedDoctor?.image ??
                                            defaultProfile
                                        }
                                        alt="Doctor"
                                        className="summary-image"
                                    />
                                </div>
                                <div
                                    className={
                                        isMobile
                                            ? "f600-16px"
                                            : "d-flex justify-content-between ms-4 w-100"
                                    }
                                >
                                    <div>{selectedDoctor?.label}</div>
                                    <div
                                        className={isMobile ? "f500-14px" : ""}
                                    >
                                        {selectedSpecialization?.label}
                                    </div>
                                </div>
                            </div>
                            <div
                                className={
                                    isMobile
                                        ? "d-flex justify-content-end gap-3 my-3 f500-16px"
                                        : "d-flex col-7 justify-content-evenly"
                                }
                            >
                                <div className="d-flex align-items-center">
                                    {formatDate(selectedAppointment?.date)}
                                </div>
                                <div className="summary-time f500-16px">
                                    {clockSvg({})}&nbsp;
                                    {selectedAppointment?.time}
                                </div>
                            </div>
                        </div>
                        <div
                            className="edit-button"
                            onClick={() => setActiveSection("filter")}
                        >
                            {editSvg({})}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default BookingSummarySection;
